import isEmpty from 'lodash-es/isEmpty'
import React from 'react'

import { Dashboard } from '@components/common'
import type { EmptyStateProps } from '@fourthwall/components'
import { HeadContent, Pagination, usePagination } from '@fourthwall/components'

import { PromotionCodesData } from '../../components/PromotionCodesData/PromotionCodesData'
import { usePromotionCodes } from '../../hooks/usePromotionCodes'

type PromotionCodesMobileProps = {
  emptyStateProps: EmptyStateProps
}

export const PromotionCodesList = ({ emptyStateProps }: PromotionCodesMobileProps) => {
  const [currentPage, setCurrentPage] = usePagination()

  const paginatedProps = usePromotionCodes()

  return (
    <>
      <HeadContent title="Promo codes" />
      <Dashboard.Section.Item>
        <PromotionCodesData
          // @ts-ignore extra empty interface Shop & Memberships are present can't seem to find a solution here
          data={paginatedProps.data || []}
          isLoading={paginatedProps.isLoading}
          emptyStateProps={emptyStateProps}
        />
      </Dashboard.Section.Item>
      {!isEmpty(paginatedProps.data) && paginatedProps.totalPages > 0 && (
        <Dashboard.Section.Item>
          <Pagination
            pageCount={paginatedProps.totalPages}
            currentPage={currentPage}
            onChange={setCurrentPage}
          />
        </Dashboard.Section.Item>
      )}
    </>
  )
}
